export default "__VITE_ASSET__BqKc1n7s__"